import { Fragment, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import moment from "moment";

import CardItemValue from "components/TableDetails/components/CardItemValue";
import { TitleInfo } from "components/TableDetails/components/TitleInfo";
import { CARD_ITEMS, CARDS } from "components/TableDetails/DeviceDetails/types";
import { renderAvailableData } from "components/TableDetails/functions";
import TableContext from "context/table/tableContext";
import { ENDPOINTS, useApi } from "shared";

import { getDateAfterSomeTime } from "../../functions";
import { LimitWarningBanner } from "../../shared";
import { DetailsData, ObdSettings } from "../../types";

const Obd = () => {
    const { detailsData } = useContext(TableContext);

    const {
        obd: { chip_version, vin, period_requests, period_start }
    }: DetailsData = detailsData;

    const { t } = useTranslation();
    const { getData, handleResponse } = useApi();

    const [dateAfter30Days, setDateAfter30Days] = useState<string | null>(null);

    useEffect(() => {
        const getObdSettings = async () => {
            try {
                const settingsResponse = await getData(ENDPOINTS.Settings);

                const obdSettings: ObdSettings =
                    settingsResponse.data.common_settings.obd;

                const isPeriodRequestsLimitReached =
                    period_requests >= obdSettings.requests_per_period;

                if (isPeriodRequestsLimitReached) {
                    const dateAfter30Days = getDateAfterSomeTime(
                        period_start,
                        obdSettings.period_length_days,
                        "days"
                    );

                    const isLimitNotExpired = moment
                        .utc(dateAfter30Days)
                        .isAfter(moment.utc());

                    isLimitNotExpired && setDateAfter30Days(dateAfter30Days);
                }
            } catch (error) {
                handleResponse(error);
            }
        };

        getObdSettings();
        // eslint-disable-next-line
    }, []);

    const list = [
        { title: CARD_ITEMS.Vin, value: vin, isAvailable: vin },
        {
            title: CARD_ITEMS.ObdChipFirmwareVersion,
            value: chip_version,
            isAvailable: chip_version
        }
    ];

    return (
        <div>
            <div>
                {t(`Table##${CARDS.Obd}`)}

                <TitleInfo
                    aria-label={t(`Table##${CARDS.Obd}`)}
                    cardName={CARDS.Obd}
                    list={list}
                />
            </div>

            {dateAfter30Days !== null && (
                <LimitWarningBanner
                    testId="obd-vin-limit-banner"
                    title={t("Table##exausted vin parsing limit")}
                    date={dateAfter30Days}
                />
            )}

            <div>
                {renderAvailableData(list).map(
                    ({ title, value, customRender }) => {
                        return (
                            <Fragment key={title}>
                                <span>{t(`Table##${title}`)}:</span>

                                <span>
                                    {customRender || (
                                        <CardItemValue value={value} />
                                    )}
                                </span>
                            </Fragment>
                        );
                    }
                )}
            </div>
        </div>
    );
};

export { Obd };
